import { useState } from "react";
import Contact from "../../Pages/Desktop/CMSPages/Contactus/Contactus";
import MContactus from "../../Pages/Mobile/MCMSPages/MContactus/MContactus";
import { internationalMobileNumber, isEmpty, validateEmail } from "../../SupportingFiles/HelpingFunctions";
import useIsMobile from "../../SupportingFiles/MobileProvider";

const ContactContainer = () => {
  const isMobile = useIsMobile();
  const [formFields, setFormFields] = useState<{
    name: { value: string; warning: boolean };
    email: { value: string; warning: boolean };
    message: { value: string; warning: boolean };
    subject: { value: string; warning: boolean };
    mobile: { value: string; warning: boolean };
    country: { value: string; warning: boolean };
  }>({
    name: { value: "", warning: false },
    email: { value: "", warning: false },
    subject: { value: "", warning: false },
    message: { value: "", warning: false },
    mobile: { value: "", warning: false },
    country: { value: "", warning: false },
  });

  const fieldsUpdateState = (attrName: any, value: string) => {
    setFormFields({
      ...formFields, [attrName[0]]: {
        value: value, warning: isEmpty(value)
      }
    })
  };

  const validateForm = () => {
    let data = { ...formFields };
    data = {
      ...data,
      name: { ...data.name, warning: isEmpty(data.name.value) },
      email: { ...data.email, warning: !validateEmail(data.email.value) },
      subject: { ...data.subject, warning: isEmpty(data.subject.value) },
      message: { ...data.message, warning: isEmpty(data.message.value) },
      mobile: { ...data.mobile, warning: !internationalMobileNumber(data.mobile.value, data.country.value) },
      country: { ...data.country, warning: isEmpty(data.country.value) },
    }
    setFormFields({ ...data });

    let hasError = false;
    Object.values(data)?.map((item) => {
      if (item.warning) hasError = true;
    });

    if (!hasError) {
      formSubmit();
    }
  };

  const formSubmit = () => {
    setFormFields({
      name: { value: "", warning: false },
      email: { value: "", warning: false },
      subject: { value: "", warning: false },
      message: { value: "", warning: false },
      mobile: { value: "", warning: false },
      country: { value: "", warning: false },
    })
  }


  return isMobile ?
    <MContactus
      formFields={formFields}
      fieldsUpdateState={fieldsUpdateState}
      validateForm={validateForm}
    />
    :
    <Contact
      formFields={formFields}
      fieldsUpdateState={fieldsUpdateState}
      validateForm={validateForm}
    />;
};

export default ContactContainer;
